import { render, staticRenderFns } from "./resource-personalize-cutup.vue?vue&type=template&id=70239dc4&"
import script from "./resource-personalize-cutup.vue?vue&type=script&lang=ts&"
export * from "./resource-personalize-cutup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports